
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { GroupSurveyExtension, GroupUserExternal } from '../../../backend/backendapi';
import GroupSurveyExtensionStore from '../../../../stores/GroupSurveyExtensionStore';
import { ExternalUserSelectModalTabFunctions } from '../../../group/EditModal/ExternalUserSelectModal/ExternalUserSelectModalTab';
import TabExternalUsers from '../../../group/EditModal/ExternalUserSelectModal/TabExternalUsers';

@Component({
  components: {
    TabExternalUsers,
  },
})
export default class ExternalUserSelectTab extends Vue implements ExternalUserSelectModalTabFunctions {
  readonly store = new GroupSurveyExtensionStore();

  clear(): void {
    this.store.loadIfAbsent();
    return (this.$refs.tab as TabExternalUsers<GroupSurveyExtension>).clear();
  }

  get selectedUsers(): GroupUserExternal[] {
    return (this.$refs.tab as TabExternalUsers<GroupSurveyExtension>).selectedUsers;
  }
}
